import debounce from 'lodash.debounce';
import { useRef } from 'react';
import { SubmitHandler } from 'react-hook-form';

export const useDebouncedSubmit = <T extends SubmitHandler<any>>(fn: T, delay = 500) => {
    return useRef(debounce(fn, delay)).current;
};
